import { FC, Fragment } from "react";
import { Alert, Link, List, ListItem, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { ConsoleTabGuide } from "./components/ConsoleTabGuide";
import { CommandSnippet } from "../../../../../../../../../common/connectors/components/CommandSnippet";
import { CopyIconButton } from "../../../../../../../../../../common/CopyIconButton";
import { useAppSelector } from "../../../../../../../../../../../store/hooks";
import { useAppAbility } from "../../../../../../../../../../../services/permissions";
import { currentAccountIdSelector } from "../../../../../../../../../../../store/account/selectors/current-account/currentAccountIdSelector";
import { currentGCPAccountServiceAccountSelector } from "../../../../../../../../../../../store/account/selectors/current-account/currentGCPAccountServiceAccountSelector";
import { useGetUsersMeProvidersGcpAccountsByAccountIdMissingRolesQuery } from "../../../../../../../../../../../services/cloudchipr.api";
import { MissingPermissionsRecheck } from "../../../../../common/MissingPermissionsRecheck";

export const GcpConsoleTab: FC = () => {
  const { can } = useAppAbility();
  const canEditAccount = can("edit", "account");

  const currentAccountId = useAppSelector(currentAccountIdSelector);
  const serviceAccount = useAppSelector(
    currentGCPAccountServiceAccountSelector,
  );

  const { data, refetch } =
    useGetUsersMeProvidersGcpAccountsByAccountIdMissingRolesQuery(
      { accountId: currentAccountId || "" },
      { skip: !currentAccountId },
    );

  if (!data?.length) {
    return null;
  }

  return (
    <Fragment>
      <Typography variant="body1">
        Please go to{" "}
        <Typography
          color="primary"
          variant="body1"
          to="https://console.cloud.google.com/iam-admin/iam"
          component={RouterLink}
          target="_blank"
        >
          IAM in GCP Console
        </Typography>{" "}
        and assign following role to Cloudchipr’s Service Account.
      </Typography>
      {serviceAccount && (
        <div>
          <Typography variant="caption" component="div" mb={-1.5}>
            Service account
          </Typography>
          <CommandSnippet code={serviceAccount} />
        </div>
      )}
      <div>
        <Typography variant="caption" mb={0.5} component="div">
          Role
        </Typography>
        <Alert
          variant="outlined"
          icon={false}
          severity="info"
          sx={{ alignItems: "center", bgcolor: "#E5F4F8", borderRadius: 2 }}
        >
          <List>
            {data?.map((p) => {
              const role = p.title || p.name;

              return (
                <ListItem key={role} sx={{ p: 0 }}>
                  {p.url && canEditAccount ? (
                    <Link href={p.url} target="_blank" fontWeight="medium">
                      {role}
                    </Link>
                  ) : (
                    <Typography
                      variant="body2"
                      color="primary"
                      fontWeight="medium"
                    >
                      {role}
                    </Typography>
                  )}

                  <CopyIconButton data={role} visible color="primary" />
                </ListItem>
              );
            })}
          </List>
        </Alert>
      </div>

      <MissingPermissionsRecheck refetch={refetch} />

      <ConsoleTabGuide />
    </Fragment>
  );
};
